import { todayEndToUnix, todayStartToUnix } from '../../utils/unixtime';
//Всегда просыпаемся с сегодня
export const reducer = (state = { mintime: todayStartToUnix(), maxtime: todayEndToUnix() }, action) => {
    switch (action.type) {
        case 'SET_PERIOD_ACTION':
            return { mintime: action.mintime, maxtime: action.maxtime };
        case 'DAY_CHANGE':
            return state;
        default:
            return state;
    }
};
